import sidebarConstants    from './sidebar.constants';
import sidebarInitialState from './sidebar.state';

function sidebarReducer(state = sidebarInitialState, action) {
  switch (action.type) {
    case sidebarConstants.SHOW_SIDEBAR:
      state = {
        ...state,
        show:    true,
        sidebar: action.sidebar,
        title:   action.title,
      };
      break;

    case sidebarConstants.HIDE_SIDEBAR:
      state = {
        ...sidebarInitialState,
      };
      break;

    case sidebarConstants.SHOW_GRATITUDE_MODAL:
      state = {
        ...state,
        isGratitudeModalOpen: true,
      };
      break;

    case sidebarConstants.HIDE_GRATITUDE_MODAL:
      state = { ...sidebarInitialState };
      break;
  }

  return state;
}

export default sidebarReducer;